<script>
export default {
  name: 'DataView',
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<template>
  <el-empty description="已跳转到数据大屏" />
</template>

<style scoped>

</style>
